<template>
    <v-layout row wrap>
        <v-flex xs12 v-show="loading">
            <v-progress-linear :indeterminate="true"></v-progress-linear>
        </v-flex>
        <v-flex xs12 v-if="!loading">
            <v-card flat>
                <v-card-title class="primary white--text headline">
                    {{'Fault Analysis'|translate}} : <span class="cursor-as-pointer mr-2 ml-2" @click="jumpToNotification(faultName,'title')">{{faultName}}</span> in <span class="cursor-as-pointer ml-2" @click="jumpToNotification(equipmentName,'equipment_name')">{{equipmentName}}</span> <span v-if="highlightTime">on {{highlightTime}}</span>
                    <v-spacer></v-spacer>
                    <date-range-selector class="mr-4" v-model="dateRange" @change="handleDateChange()" ></date-range-selector>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }" >
                            <v-icon
                                    class="mr-2"
                                    v-on="on"
                                    @click="focusRange()"
                            >
                                fa-compress
                            </v-icon>
                        </template>
                        <span>{{'Focus Range'|translate}}</span>
                    </v-tooltip>
                    <equipment-context-menu :equipment="equipmentName" :date-range="dateRange"
                                            fault model-summary notification-breakdown equipment-summary
                    >
                        <v-list-tile  @click="exportAll()">
                            <v-list-tile-title>{{'Export all as PDF'|translate}}</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile v-if="nId"  @click="$router.push({path: '/notifications',query: {id:nId}})">
                            <v-list-tile-title>{{'View Notification'|translate}}</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile v-if="rule&&equipment&&equipment.floor"  @click="$router.push({path: '/fault-comparison',query: {rangeStart:dateRange.start,rangeEnd:dateRange.end,floor:equipment.floor,rule:rule.title,}})">
                            <v-list-tile-title>{{'View this rule on other equipments in'|translate}} {{equipment.floor}}</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile  v-if="equipmentName" @click="handleMaintenanceClick">
                            <v-list-tile-title>{{'Create Maintenance Record'|translate}}</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile v-if="equipmentName"  @click="$router.push({path: '/equipments',query: {search:equipmentName}})">
                            <v-list-tile-title>{{'View Equipment'|translate}}</v-list-tile-title>
                        </v-list-tile>
                    </equipment-context-menu>

                    <fault-record-dialog v-model="maintenanceDialog" :item="maintenanceItem"></fault-record-dialog>
                </v-card-title>
                <v-card-text>
                <v-layout row wrap>
                    <v-flex xs12 v-if="rule">
                        <v-progress-linear :indeterminate="true" v-if="!data1"></v-progress-linear>
                        <vue-plotly disable-responsive v-if="data1" :data="data1" :layout="layout1" ref="feplot" :options="{}"/>
                        <p v-if="rule.desc"><strong>{{'Description'|translate}} : </strong>{{rule.desc}}</p>
                        <p v-if="nId"><strong>{{'Notification ID'|translate}} : </strong>{{nId}}</p>
                        <p v-if="nTopic"><strong>{{'Topic'|translate}} : </strong>{{nTopic}}</p>
                        <p v-if="nOct"><strong>{{'Occurred Times'|translate}} : </strong>{{nOct}} {{'times'|translate}} | {{nOcDuration.toFixed(2)}} day(s)</p>
                        <p v-if="rule.recommended_actions"><strong>{{'Recommended actions'|translate}} : </strong></p>
                        <ul v-if="rule.recommended_actions">
                            <li v-for="i in rule.recommended_actions.split('\n')">{{i}}</li>
                        </ul>
                        <p v-if="equipment&&equipment.notes"><strong>{{'Equipment notes'|translate}} : </strong>{{equipment.notes}}</p>
                        <div id="printdetails" v-show="showPrintDetails">
                            <v-layout row wrap>
                                <v-flex xs6 class="pa-2">
                                    <h3>Notification Information Table</h3>
                                    <table style="width:100%">
                                        <tr v-if="nId">
                                            <th>{{'ID'|translate}}</th>
                                            <th style="width: 90%">{{nId}}</th>
                                        </tr>
                                        <tr v-if="equipmentName">
                                            <th>{{'Equipment Name'|translate}}</th>
                                            <th>{{equipmentName}}</th>
                                        </tr>
                                        <tr>
                                            <td>{{'Fault'|translate}}</td>
                                            <td>{{faultName}}</td>
                                        </tr>
                                        <tr v-if="nTopic">
                                            <td>{{'Topic'|translate}}</td>
                                            <td>{{nTopic}}</td>
                                        </tr>
                                        <tr v-if="equipment&&equipment.floor">
                                            <td>{{'Location'|translate}}</td>
                                            <td>{{equipment.floor}}</td>
                                        </tr>
                                        <tr>
                                            <td>{{'Start Time'|translate}}</td>
                                            <td>{{dateRange.start}}</td>
                                        </tr>
                                        <tr>
                                            <td>{{'End Time'|translate}}</td>
                                            <td>{{dateRange.end}}</td>
                                        </tr>
                                        <tr v-if="nOct">
                                            <td>{{'Occurred Times'|translate}}</td>
                                            <td>{{nOct}} {{'times'|translate}} | {{nOcDuration.toFixed(2)}} day(s)</td>
                                        </tr>
                                        <tr v-if="rule.desc">
                                            <td>{{'Description'|translate}}</td>
                                            <td>{{rule.desc}}</td>
                                        </tr>
                                        <tr v-if="rule.recommended_actions">
                                            <td>{{'Recommended actions'|translate}}</td>
                                            <td>
                                                <ul v-if="rule.recommended_actions">
                                                    <li v-for="i in rule.recommended_actions.split('\n')">{{i}}</li>
                                                </ul>
                                            </td>
                                        </tr>
                                    </table>
                                </v-flex>
                                <v-flex xs6 class="pa-2">
                                    <h3>Action Table</h3>
                                    <table style="width:100%">
                                        <tr>
                                            <th>{{'Assigned to'|translate}}</th>
                                            <th style="width: 90%"></th>
                                        </tr>
                                        <tr style="height: 200px">
                                            <th>{{'Comments'|translate}}</th>
                                            <th> </th>
                                        </tr>
                                        <tr style="height: 200px">
                                            <th>{{'Actions Taken'|translate}}</th>
                                            <th> </th>
                                        </tr>
                                        <tr>
                                            <th>{{'Reported by'|translate}}</th>
                                            <th> </th>
                                        </tr>
                                        <tr>
                                            <th>{{'Report date'|translate}}</th>
                                            <th> </th>
                                        </tr>
                                        <tr>
                                            <th>{{'Certified by'|translate}}</th>
                                            <th> </th>
                                        </tr>
                                        <tr>
                                            <th>{{'Certified date'|translate}}</th>
                                            <th> </th>
                                        </tr>
                                        <tr>
                                            <th>{{'Endorsed by'|translate}}</th>
                                            <th> </th>
                                        </tr>
                                        <tr>
                                            <th>{{'Endorsed date'|translate}}</th>
                                            <th> </th>
                                        </tr>
                                    </table>
                                </v-flex>
                            </v-layout>
                        </div>
                    </v-flex>
                    <v-flex xs12 v-if="!loading&&variableList">
                        <v-card class="elevation-2" flat>
                            <data3-chart v-for="(unitVars,unitName) in variableList" :key="'rv'+unitName" class="ma-2 mb-2"
                                         :layout-overrides="{shapes:shapes,title:relvtitle,height:300,margin:layoutOverrides.margin,yaxis:{title:unitName,fixedrange: true},showlegend: true,legend:{...layoutOverrides.legend},xaxis:{...layoutOverrides.xaxis},hovermode:layoutOverrides.hovermode,hoverlabel:layoutOverrides.hoverlabel}"
                                         :on-only="false"
                                         :x-axis="'timestamp'"
                                         disable-responsive
                                         :show-export="false"
                                         ref="rvplots"
                                         just-plot
                                         :data-payload="unitVars"
                                         :date-range="dateRange"></data3-chart>
                            <v-alert v-if="faultyRelVars&&faultyRelVars.length>0"
                                :value="true"
                                style="padding: 6px;"
                                type="warning"
                            >
                                {{'Faulty sensors : '|translate}}
                                <v-chip  v-for="faultySensor in faultyRelVars" >{{faultySensor}}</v-chip>
                            </v-alert>
                        </v-card>
                    </v-flex>
                    <v-flex xs12 v-if="!loading&&equipment&&equipment.graphic_id">
                        <equipment-graphic-renderer :graphic-id="equipment.graphic_id" :selected-equipments="[equipmentName]"></equipment-graphic-renderer>
                    </v-flex>
                    <v-flex xs12 v-if="!loading&&rule&&rule.meta&&rule.meta.custom_view">
                        <component v-if="customViewDefinition" v-bind:is="customViewDefinition.viewType" v-bind:itemDefinition="customViewDefinition" embedded-mode v-bind:embedded-equip="equipmentName" v-bind:range-override="dateRange"></component>
                    </v-flex>
                    <v-flex xs12 v-if="!loading&&fullVariableList">
                        <data3-chart v-for="fulVarItem in fullVariableList" :key="fulVarItem.key"
                                     :layout-overrides="{shapes:layoutOverrides.shapes,height:300,margin:layoutOverrides.margin,yaxis:{title:fulVarItem.unit,fixedrange: true},showlegend: true,legend:{...layoutOverrides.legend},xaxis:{...layoutOverrides.xaxis},hovermode:layoutOverrides.hovermode,hoverlabel:layoutOverrides.hoverlabel}"
                                     :on-only="false"
                                     :x-axis="'timestamp'"
                                     ref="plots"
                                     just-plot
                                     disable-responsive
                                     :show-export="false"
                                     :data-payload="fulVarItem.varList"
                                     :date-range="dateRange"></data3-chart>
                    </v-flex>

                </v-layout>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import Data3Chart from "../components/Data3Chart";
    import exportAllToPDF from '../components/mixins/exportAllToPDF'
    import printer from "../components/mixins/printer";
    import {getPoint,getRule,callAPI,getParameter} from '../helper'
    import VuePlotly from "../components/VuePlotly";
    import DateRangeSelector from "../components/DateRangeSelector";
    import FaultRecordDialog from "../components/FaultRecordDialog";
    import EquipmentContextMenu from "../components/EquipmentContextMenu";
    import EquipmentGraphicRenderer from "../components/EquipmentGraphicRenderer";
    import PlotList from "./automated/PlotList";
    import {mapGetters} from 'vuex'
    import moment from 'moment'
    export default {
        name: 'FaultAnalysis',
        components: {VuePlotly,DateRangeSelector,FaultRecordDialog,EquipmentContextMenu,Data3Chart,EquipmentGraphicRenderer,PlotList},
        mixins:[exportAllToPDF,printer],
        computed: {
            ...mapGetters([
                'publishedCustomViews','hiddenPointsConfig','mappingIntegrityConfig',
            ]),
            customViewDefinition() {
                if (!this.loading&&this.rule&&this.rule.meta&&this.rule.meta.custom_view&&this.rule.meta.custom_view!==""){
                    for (let item of this.publishedCustomViews){
                        if(item.id===this.rule.meta.custom_view){
                            return item
                        }
                    }
                }
                return null
            },
        },
        data () {
            return {
                loading:true,
                relvtitle:this.$options.filters.translate('Relevant variables'),
                rule:null,
                maintenanceDialog: false,
                maintenanceItem: null,
                showPrintDetails:false,
                equipment:null,
                severityColors:{
                    critical:'rgb(148, 103, 189)',
                    low:'rgb(188, 189, 34)',
                    medium:'rgb(255, 127, 14)',
                    high:'rgb(214, 39, 40)',
                },
                dateRange: {start: null, end: null},
                equipmentName: null,
                faultDesc: null,
                highlightTime:null,
                relevantVariables:null,
                faultyRelVars:[],
                faultName:null,
                shapes:[],
                variableList:[],
                layoutOverrides:{},
                layout1:null,
                data1:null,
                parameter:null,
                points:[],
                plots:[],
                allVars:null,
                fullVariableList:null,
                nId:null,
                nTopic:null,
                nOct:null,
                nOcDuration:null,
            }
        },
        methods:{
            printReport(){
                this.printPage('#carnotMainContent',this.equipmentName+"-"+this.dateRange.start)
            },
            focusRange(){
                if(this.shapes&&this.shapes.length>0){
                    let lastShape=JSON.parse(JSON.stringify(this.shapes[this.shapes.length-1]))
                    let end=moment(lastShape.x1).add(6,'hours').format('YYYY-MM-DD HH:mm:ss')
                    let start=moment(lastShape.x0).subtract(8,'days').subtract(6,'hours').format('YYYY-MM-DD HH:mm:ss')
                    this.dateRange= {start: start, end: end}
                }
            },
            async exportAll(){
                let plots=[...this.$refs.plots]
                if(this.$refs.rvplots){
                    for (let item of this.$refs.rvplots){
                        plots.unshift(item)
                    }
                }
                let title=this.equipmentName+"="+this.dateRange.start
                if(this.nId){
                    title=title+"="+this.nId
                    this.showPrintDetails=true
                    await this.sleep(1000)
                    plots.unshift("#printdetails")
                }
                if(this.$refs.feplot){
                    plots.unshift(this.$refs.feplot)
                }
                await this.exportAllItems(plots,title);
                if(this.nId){
                    await this.sleep(1000)
                    this.showPrintDetails=false
                }
            },
            jumpToNotification(value,facet) {
                let output = {
                    path: '/notification-breakdown',
                    query:{
                        rangeStart: this.dateRange.start,
                        rangeEnd: this.dateRange.end,
                    }
                }
                output.query[facet]=value
                this.$router.push(output)
            },
            handleDateChange(){
              this.renderPlots()
            },
            relayout(ed) {
                let plots=[]
                for (let item of this.$refs.plots){
                    if (item.$refs.plotly){
                        plots.push(item.$refs.plotly.$refs.container)
                    }
                }
                if(this.$refs.feplot){
                    plots.push(this.$refs.feplot.$refs.container)
                }
                if(this.$refs.rvplots){
                    for (let item of this.$refs.rvplots){
                        if (item.$refs.plotly){
                            plots.push(item.$refs.plotly.$refs.container)
                        }
                    }
                }
                for (let plot of plots){
                    if(plot.layout) {
                        let x = plot.layout.xaxis;
                        if (x.range[0] !== ed["xaxis.range[0]"] || x.range[1] !== ed["xaxis.range[1]"]) {
                            plot.relayout(ed);
                        }
                    }
                }
            },
            doInitialReload(){
                let me=this;
                if(!me.$refs.feplot){
                    setTimeout(function(){ me.doInitialReload()}, 3000);
                } else {
                    me.$refs.feplot.$refs.container.relayout(
                        {
                            'xaxis.autorange': true
                        }
                    )

                }

            },
            initPlotlySync(){
                let plots=[]
                let me=this;
                if(!this.$refs.plots||(me.variableList.length>0&&(!this.$refs.rvplots||!this.$refs.rvplots[0].$refs.plotly))||(me.rule&&!this.$refs.feplot)){
                    setTimeout(function(){ me.initPlotlySync()}, 2000);
                } else {
                    for (let item of this.$refs.plots){
                        if (item.$refs.plotly){
                            plots.push(item.$refs.plotly.$refs.container.$el)
                        }
                    }
                    if(this.$refs.feplot){
                        plots.push(this.$refs.feplot.$refs.container.$el)
                    }
                    if(this.$refs.rvplots){
                        for (let item of this.$refs.rvplots){
                            if (item.$refs.plotly){
                                plots.push(item.$refs.plotly.$refs.container.$el)
                            }
                        }
                    }
                    me.plots=plots;
                    plots.forEach(div => {
                        if(div.on) {
                            div.on("plotly_relayout", ed => {
                                if (!ed.autosize) {
                                    let newl = {
                                        "xaxis.range[0]": div.layout.xaxis.range[0],
                                        "xaxis.range[1]": div.layout.xaxis.range[1],
                                    }
                                    me.relayout(newl);
                                }
                            });
                        }
                    });
                }



            },
            async renderPlots(){
                let me=this;
                me.loading=true
                me.data1=null
                // me.othersFEData=null
                for (let i in this.$store.state.pointsListStore.pointsList.equipment_details) {
                    if (this.$store.state.pointsListStore.pointsList.equipment_details[i].equipment_name===this.equipmentName){
                        this.equipment = this.$store.state.pointsListStore.pointsList.equipment_details[i];
                        this.allVars=this.$store.state.pointsListStore.pointsList.sensors[i]
                        break
                    }
                }
                if (this.hiddenPointsConfig){
                    let pointsToHide=[]
                    if (this.hiddenPointsConfig[this.equipment.equipment_type]){
                        pointsToHide=pointsToHide.concat(this.hiddenPointsConfig[this.equipment.equipment_type])
                    }
                    if (this.hiddenPointsConfig['*']){
                        pointsToHide=pointsToHide.concat(this.hiddenPointsConfig['*'])
                    }
                    this.allVars=this.allVars.filter(x=>!pointsToHide.includes(x))
                }
                if(this.faultDesc){
                    getRule({
                        facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                    }).then(function (rules) {
                        for (let rule of rules.result) {
                            if (rule.title == me.faultName && me.equipment.equipment_type == rule.equipment_group) {
                                me.rule = rule
                                me.faultDesc = me.rule.desc
                                break
                            }
                        }
                                callAPI('issue/',
                                    {
                                        'facility_name': me.$store.state.pointsListStore.pointsList.facility_name,
                                        'issue': me.faultName,
                                        'equipment_name': me.equipmentName,
                                        'date_range': [me.dateRange.start, me.dateRange.end]
                                    }
                                ).then(function (issueRes) {
                                    let df=issueRes.data
                                    let timeAxis=[];
                                    let ts=moment(me.dateRange.start).format('YYYY-MM-DD HH:mm:ss')
                                    let end=moment(me.dateRange.end).format('YYYY-MM-DD HH:mm:ss')
                                    while (ts<=end){
                                        timeAxis.push(ts)
                                        ts=moment(ts).add(me.$store.getters.minutesBetweenSamples,'minutes').format('YYYY-MM-DD HH:mm:ss')
                                    }
                                    let refinedDf={
                                        x:timeAxis,
                                        y:[...new Set(df['issue'])],
                                        z:[]
                                    }
                                    let prefiller=null
                                    if(me.rule&&me.rule.rule.match(/rolling\((.*?)\)/g)){
                                        try {
                                            let matchedset=me.rule.rule.match(/rolling\((.*?)\)/g)
                                            let roller=matchedset[matchedset.length-1].match(/rolling\((.*?)\)/)[1]
                                            if(roller.indexOf("config[")>-1&&me.parameter){
                                                for (let parameter of me.parameter){
                                                    roller=roller.replace("config['"+parameter.parameter_name+"']",parameter.parameter_value)
                                                }
                                            }
                                            prefiller=eval(roller)
                                        } catch (e) {
                                            prefiller=null
                                        }

                                    }
                                    for (let issue of refinedDf.y){
                                        let newZ=new Array(timeAxis.length).fill(false);
                                        for (let index in df['issue']){
                                            if(df['issue'][index]===issue){
                                                newZ[timeAxis.indexOf(df['timestamp'][index])]=true;
                                                if(prefiller){
                                                    let base=timeAxis.indexOf(df['timestamp'][index])
                                                    for(let i=1;i<=prefiller;i++){
                                                        if(timeAxis[base-i]){
                                                            newZ[base-i]=true
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        refinedDf.z.push(newZ)
                                    }
                                    if(!refinedDf.z[0]){
                                        refinedDf.z[0]=new Array(timeAxis.length).fill(false)
                                    }
                                    let shape=null
                                    let shapes=[]
                                    let mainShapes=[]
                                    for (let index in refinedDf.z[0]){
                                        if(refinedDf.z[0][index]&&index<refinedDf.z[0].length-1){
                                            if(!shape){
                                                shape={
                                                    x0:refinedDf.x[index],
                                                    x1:refinedDf.x[index],
                                                    yref: 'paper',
                                                    y0: 0,
                                                    type:"rect",
                                                    octCount:1,
                                                    y1: 1,
                                                    fillcolor: me.rule ? me.severityColors[me.rule.severity.toLowerCase()] : me.severityColors["high"],
                                                    opacity: 0.20,
                                                    line: {
                                                        width: 0
                                                    }
                                                }
                                            } else {
                                                shape.x1=refinedDf.x[index]
                                                shape.octCount=shape.octCount+1
                                            }
                                        } else {
                                            if(shape){
                                                if(shape.x0==shape.x1){
                                                    shape.x1=moment(shape.x1).add(me.$store.getters.minutesBetweenSamples,'minute').format('YYYY-MM-DD HH:mm:ss')
                                                }
                                                shapes.push({...shape})
                                                shape.opacity=1
                                                mainShapes.push(shape)
                                                shape=null
                                            }
                                        }
                                    }
                                    me.shapes=shapes;
                                    me.nOct=shapes.length
                                    me.nOcDuration= shapes.reduce((sum, x) => sum + x.octCount,0)/me.$store.state.pointsListStore.pointsList.sampling_freq/24
                                    me.data1 = [
                                        {
                                            x: refinedDf.x,
                                            y: refinedDf.z[0],
                                            name: me.$options.filters.translate('Rule evaluation'),
                                            type: 'scatter',
                                            mode: 'none',
                                        },
                                    ]
                                    me.layout1={
                                        height:90,
                                        margin:{
                                          t:30,
                                          b:30
                                        },
                                        plot_bgcolor:'rgb(31, 119, 180)',
                                        title:me.$options.filters.translate('Rule evaluation')+' : '+me.faultName,
                                        yaxis: {
                                            title: 'Rule',
                                            fixedrange: true,
                                            categoryorder: 'array',
                                            range: [0, 1],
                                            showticklabels:false,
                                            categoryarray: ["false", "true"],
                                            showgrid:false,
                                        },
                                        shapes:mainShapes,
                                        xaxis: {
                                            title: '',
                                            showgrid:false,
                                        },
                                        hoverlabel: { bgcolor: "#606060" },
                                    }
                                    setTimeout(function(){ me.initPlotlySync()}, 2000);
                                    setTimeout(function(){ me.doInitialReload()}, 3000);
                                })

                    })
                } else {
                    setTimeout(function(){ me.initPlotlySync() }, 2000);
                }
                let relVarList={};
                this.faultyRelVars=[]
                for (let varName of this.relevantVariables){
                    if(varName.indexOf(" - ")>-1){
                        let extVarName=varName.split(" - ")[1]
                        let extEquipName=varName.split(" - ")[0]
                        let unit = this.getUnit(extVarName,extEquipName)
                        if (!relVarList[unit]) {
                            relVarList[unit] = [];
                        }
                        let desc=this.getVarDetails(extVarName,extEquipName).sensor_desc
                        if(this.getVarDetails(extVarName,extEquipName).faulty){
                            this.faultyRelVars.push(this.equipmentName+" - "+varName)
                        }
                        let pad= desc ? " - "+desc : ""
                        let unitpad= unit&&unit!=="" ? " ("+unit+")" : ""
                        relVarList[unit].push({
                            'filters': {
                                equipment_name: extEquipName,
                                sensor_name: extVarName,
                                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                            },
                            pipeline: [
                                {
                                    type: "calculate",
                                    formula: 'df["' + varName + '"]',
                                    name: varName + pad + unitpad,
                                    "remove_others": true
                                }
                            ],
                            seriesOverrides: {
                                type: 'scatter',
                                opacity: 1,
                                xbins: {
                                    size: 1
                                },
                                ybins: {
                                    size: 1
                                }
                            },
                        })
                    } else {
                        let unit = this.getUnit(varName)
                        if (!relVarList[unit]) {
                            relVarList[unit] = [];
                        }
                        let desc = this.getVarDetails(varName).sensor_desc
                        if(this.getVarDetails(varName).faulty){
                            this.faultyRelVars.push(this.equipmentName+" - "+varName)
                        }
                        let pad = desc ? " - " + desc : ""
                        let unitpad = unit && unit !== "" ? " (" + unit + ")" : ""
                        relVarList[unit].push({
                            'filters': {
                                equipment_name: this.equipmentName,
                                sensor_name: varName,
                                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                            },
                            pipeline: [
                                {
                                    type: "calculate",
                                    formula: 'df["' + this.equipmentName + ' - ' + varName + '"]',
                                    name: varName + pad + unitpad,
                                    "remove_others": true
                                }
                            ],
                            seriesOverrides: {
                                type: 'scatter',
                                opacity: 1,
                                xbins: {
                                    size: 1
                                },
                                ybins: {
                                    size: 1
                                }
                            },
                        })
                    }
                }
                this.variableList=relVarList;
                if(this.allVars){
                    let priorityVarList={}
                    let priorityVars=[]
                    if (this.mappingIntegrityConfig){
                        priorityVars=this.mappingIntegrityConfig.filter(x=>x.equipmentGroup===this.equipment.equipment_type).map(x=>x.carnotname)
                    }
                    let newVarList={};
                    for (let varName of this.allVars){
                        let unit = this.getUnit(varName)
                        if (priorityVars.includes(varName)){
                            if (!priorityVarList[unit]) {
                                priorityVarList[unit] = [];
                            }
                        } else {
                            if (!newVarList[unit]) {
                                newVarList[unit] = [];
                            }
                        }

                        let desc = this.getVarDetails(varName).sensor_desc
                        let pad = desc ? " - " + desc : ""
                        let unitpad = unit && unit !== "" ? " (" + unit + ")" : ""
                        let newItem={
                            'filters': {
                                equipment_name: this.equipmentName,
                                sensor_name: varName,
                                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                            },
                            pipeline: [
                                {
                                    type: "calculate",
                                    formula: 'df["' + this.equipmentName + ' - ' + varName + '"]',
                                    name: varName + pad + unitpad,
                                    "remove_others": true
                                }
                            ],
                            seriesOverrides: {
                                type: 'scatter',
                                opacity: 1,
                                xbins: {
                                    size: 1
                                }
                            },
                        }
                        if (priorityVars.includes(varName)){
                            priorityVarList[unit].push(newItem)
                        } else {
                            newVarList[unit].push(newItem)
                        }
                    }
                    let finalList=[];
                    for (let unit in priorityVarList){
                        finalList.push({
                            unit:unit,
                            key:"important"+unit,
                            varList:priorityVarList[unit]
                        })
                    }
                    for (let unit in newVarList){
                        finalList.push({
                            unit:unit,
                            key:"other"+unit,
                            varList:newVarList[unit]
                        })
                    }
                    this.fullVariableList=finalList
                }
                this.layoutOverrides={
                    title:this.$options.filters.translate("Relevant variables"),
                    xaxis: {
                        title: '',
                    },
                    yaxis:{
                        fixedrange: true
                    },
                    margin:{
                        t: 30,
                        b:0
                    },
                    height:300,
                    showlegend:true,
                    legend: {
                        orientation:'h',
                        y: -0.2,
                    },
                    hoverlabel: {
                        namelength: -1
                    },
                    hovermode:"x",
                    shapes: this.highlightTime ? [
                        {
                            type: 'line',
                            x0:this.highlightTime,
                            y0: 0,
                            x1: this.highlightTime,
                            y1: 1,
                            yref: 'paper',
                            line:{
                                color: 'red',
                                width: 4,
                            }
                        }
                    ] : [],
                }
                this.loading=false
            },
            getUnit(varName, equipmentName = null){
                if(!equipmentName){
                    equipmentName=this.equipmentName
                }
                for (let point of this.points){
                    if(point.sensor_name===varName&&point.equipment_name===equipmentName){
                        if(point.unit){return point.unit}
                        break
                    }
                }
                if(varName.toLowerCase().includes("tem")){
                    return "°C"
                } else if(varName.toLowerCase().includes("press")){
                    return "kPa"
                } else if(varName.toLowerCase().includes("status")){
                    return "status"
                } else if(varName.toLowerCase().includes("_hr")){
                    return "hour"
                }
                return "";
            },
            getVarDetails(varName,equipmentName=null){
                if(!equipmentName){
                    equipmentName=this.equipmentName
                }
                for (let point of this.points){
                    if(point.sensor_name===varName&&point.equipment_name===equipmentName){
                        return point
                    }
                }
                return {}
            },
            handleMaintenanceClick(){
                this.maintenanceItem=JSON.parse(JSON.stringify({
                    'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                    'equipment': this.equipmentName,
                    'maintenance_date_from': this.$refs.feplot ? moment(this.$refs.feplot.$refs.container.layout.xaxis.range[0]).format('YYYY-MM-DD HH:mm:ss') : this.dateRange.start,
                    'maintenance_date_to': this.$refs.feplot ? moment(this.$refs.feplot.$refs.container.layout.xaxis.range[1]).format('YYYY-MM-DD HH:mm:ss') : this.dateRange.end,
                    'maintenance_text': this.rule&&this.rule.recommended_actions ? 'Recommended Actions: \n\n' + this.rule.recommended_actions : "", 
                    'maintenance_label': this.rule&&this.rule.title ? this.rule.title : "Anomaly",
                    'url': '/fault-analysis'+window.location.search,
                    is_fixed: false,
                    maintenance_id: null
                }))
                if (this.nId){
                    this.maintenanceItem.notification_id=this.nId
                }
                if (this.rule&&this.rule.severity){
                    this.maintenanceItem.severity=this.rule.severity
                }
                this.maintenanceDialog=true
            }
        },
         beforeMount(){

            this.equipmentName = _.get(this.$route.query,'equipmentName', null)
            let endTest=moment(_.get(this.$route.query,'rangeEnd')).add(5,'hours').format('YYYY-MM-DD HH:mm:ss')
            let now=moment().format('YYYY-MM-DD HH:mm:ss')
            this.dateRange={
                start:moment(_.get(this.$route.query,'rangeStart')).subtract(5,'hours').format('YYYY-MM-DD HH:mm:ss'),
                end:endTest>now ? now : endTest
            }
            this.highlightTime =  _.get(this.$route.query,'highlightTime', null)
            this.faultDesc =  _.get(this.$route.query,'faultDesc', null)
            this.nId =  _.get(this.$route.query,'nId', null)
            this.nTopic =  _.get(this.$route.query,'nTopic', null)
            this.nOct =  _.get(this.$route.query,'nOct', null)
            this.nOcDuration =  (_.get(this.$route.query,'nOct', null)/this.$store.state.pointsListStore.pointsList.sampling_freq) 
            let relvs=_.get(this.$route.query,'relevantVariables', null)
            this.relevantVariables = relvs&&relvs!=='0'&&relvs!=='' ? relvs.split(',').map(x=>x.trim()) : [];
            this.faultName =  _.get(this.$route.query,'faultName', '')
        },
        async mounted(){
            let df1 = await getParameter({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name
            })
            this.parameter = df1['result']
            let df = await getPoint({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                equipment_name:this.equipmentName
            })
            this.points = df['result']
            this.renderPlots()
        },
    }
</script>
<style scoped>
    #printdetails{
        color: #202020;
        font-size: 18px;
        font-weight: bold;
    }
    #printdetails table, th, td{
        border: 1px solid #999999;
        border-collapse: collapse;
    }
    #printdetails th, td {
        padding: 4px;
        text-align: left;
    }
    #printdetails table{
        height:700px;
    }
</style>
